import { IRegion } from 'store/user/types/state.types';
import { readSessionItem, writeSessionItem } from 'utils/session-storage';

const TAB_REGION_KEY = 'tabRegion';

type TabRegion = {
  userId: number
  region: IRegion
};

// Регион на бэкенде один на аккаунт, а во вкладках он может быть разным,
// поэтому выбранный во вкладке регион храним в sessionStorage (он не общий между вкладками)
export function readTabRegion(userId: number): IRegion | null {
  const saved = readSessionItem<TabRegion | null>(TAB_REGION_KEY, null);
  return saved && saved.userId === userId ? saved.region : null;
}

export function writeTabRegion(userId: number, region: IRegion): void {
  const value: TabRegion = { userId, region };
  writeSessionItem(TAB_REGION_KEY, value);
}
